/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './temperature.reducer';

export const TemperatureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const temperatureEntity = useAppSelector(state => state.temperature.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="temperatureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.temperature.detail.title">Temperature</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.temperature.id">Id</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.temperature.value">Value</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.value}</dd>
          <dt>
            <span id="time">
              <Translate contentKey="tinyMedicRestApp.temperature.time">Time</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.time}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.temperature.type">Type</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.type}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.temperature.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.comments}</dd>
          <dt>
            <span id="forJanani">
              <Translate contentKey="tinyMedicRestApp.temperature.forJanani">For Janani</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.forJanani ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.temperature.active">Active</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.temperature.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.temperature.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.temperature.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.temperature.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.temperature.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{temperatureEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.temperature.cycleDay">Cycle Day</Translate>
          </dt>
          <dd>{temperatureEntity.cycleDay ? temperatureEntity.cycleDay.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/temperature" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/temperature/${temperatureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TemperatureDetail;
